import React from "react";
import "../styles/Preloader.css";

const Preloader = () => {
  return (
    <div id="preloader">
      <div className="spinner"></div>
    </div>
  );
};

export default Preloader;
